import { jsx } from "react/jsx-runtime";
import { Box } from "../Box/Box.mjs";
import { buildDataAttributes } from "../private/buildDataAttributes.mjs";
import { marginAuto } from "./ContentBlock.css.mjs";
const ContentBlock = ({
  width = "medium",
  align = "center",
  data,
  children,
  ...restProps
}) => /* @__PURE__ */ jsx(
  Box,
  {
    width: "full",
    maxWidth: width,
    className: align === "left" ? void 0 : marginAuto,
    ...buildDataAttributes({ data, validateRestProps: restProps }),
    children
  }
);
export {
  ContentBlock
};
